import React from 'react';
export function GiftCardSection() {
  return <section id="gift-cards" className="relative py-24 md:py-32 flex items-center justify-center" style={{
    backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/xo4ipwv6sPSEezVgHNYToU/raise_the_bar_june_2024-118.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed'
  }} data-id="element-67">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60 z-0" data-id="element-68"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-3xl mx-auto" data-id="element-69">
        <h2 className="text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-70">
          Give the Gift of Glow
        </h2>

        <p className="text-lg md:text-xl text-white/90 mb-10 leading-relaxed" style={{
        fontFamily: "'Montserrat', sans-serif"
      }} data-id="element-71">
          Raise The Bar Med Spa gift cards — perfect for any occasion. Flexible
          amounts, redeemable for any service.
        </p>

        <a href="#shop-gift-cards" className="inline-flex items-center justify-center bg-[#C8A84E] hover:bg-[#b39542] text-black px-10 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 min-h-[48px] text-lg" style={{
        fontFamily: "'Montserrat', sans-serif"
      }} data-id="element-72">
          Shop Gift Cards
        </a>
      </div>
    </section>;
}